import { apiService } from "../../app.service";

export const settingApi = apiService.injectEndpoints({
  endpoints: (builder) => ({
    // ===== ALERT EMAIL =====
    updateAlertEmail: builder.mutation({
      query: (data) => ({
        url: "/user/update-alert-email/",
        method: "POST",
        body: data,
      }),
    }),
    
    getAlertEmail: builder.query({
      query: () => ({
        url: "/alert-email/",
      }),
    }),

    // ===== ALERT SMS =====
    getAlertSMS: builder.query({
      query: () => ({
        url: "/sms",
      }),
    }),
    
    updateAlertSMS: builder.mutation({
      query: (data) => ({
        url: "/update-sms",
        method: "POST",
        body: data,
      }),
    }),

    // ===== CHECKLIST DUE TIME =====
    updateCheckDueTime: builder.mutation({
      query: ({ type, data }) => ({
        url: `/checklists/type/${type}/due-time`,
        method: "PATCH",
        body: data,
      }),
    }),
    
    getCheckDueTime: builder.query({
      query: (type) => ({
        url: `/checklists/type/${type}/due-time`,
      }),
    }),

    // ===== INCIDENT DUE TIME =====
    updateIncidentDueTime: builder.mutation({
      query: (data) => ({
        url: `/incidents/due-time`,
        method: "POST",
        body: data,
      }),
    }),
    
    getIncidentDueTime: builder.query({
      query: () => ({
        url: `/incidents/due-time`,
      }),
    }),

    // ===== TIMEZONE =====
    updateTimezone: builder.mutation({
      query: (data) => ({
        url: "/restaurant/update-timezone",
        method: "PUT",
        body: data,
      }),
    }),
    
    getTimezone: builder.query({
      query: () => ({
        url: "/user/restaurant/timezone",
      }),
    }),

    // ===== MONTHLY DUE TIME =====
    getMonthlyDueTime: builder.query({
      query: () => ({
        url: "/restaurant/due-time/monthly",
      }),
    }),
    
    updateMonthlyDueTime: builder.mutation({
      query: (data) => ({
        url: "/restaurant/due-time/monthly",
        method: "PUT",
        body: data,
      }),
    }),

    // ===== CHECKLIST SETTINGS =====
    fetchChecklistSettings: builder.query({
      query: () => ({
        url: "/restaurant/checklist-settings",
      }),
    }),

    // ===== CHECKLIST VISIBILITY =====
    getChecklistVisibility: builder.query({
      query: () => ({
        url: "/checklists/visibility",
      }),
    }),

    updateChecklistVisibility: builder.mutation({
      query: (data) => ({
        url: "/checklists/visibility",
        method: "PUT",
        body: data,
      }),
    }),

    getChecklistTypeVisibility: builder.query({
      query: (type) => ({
        url: `/checklists/visibility/${type}`,
      }),
    }),

    updateChecklistTypeVisibility: builder.mutation({
      query: ({ type, visible }) => ({
        url: `/checklists/visibility/${type}`,
        method: "PATCH",
        body: { visible },
      }),
    }),

    resetChecklistVisibility: builder.mutation({
      query: () => ({
        url: "/checklists/visibility/reset",
        method: "POST",
      }),
    }),

    bulkUpdateVisibility: builder.mutation({
      query: (data) => ({
        url: "/user/checklists/visibility/bulk",
        method: "PATCH",
        body: data,
      }),
    }),
    
       // Holiday/Away endpoints
    enableHolidayMode: builder.mutation({
      query: (data) => ({
        url: "/restaurant/holiday/enable",
        method: "POST",
        body: data,
      }),
    }),
    
    disableHolidayMode: builder.mutation({
      query: () => ({
        url: "/restaurant/holiday/disable",
        method: "POST",
      }),
    }),
    
    getHolidayStatus: builder.query({
      query: () => "/restaurant/holiday/status",
    }),
    
    // Opening hours endpoints
getOpeningHours: builder.query({
  query: () => "/restaurant/opening-hours",  
}),

// Line 2 - updateOpeningHours  
updateOpeningHours: builder.mutation({
  query: (data) => ({
    url: "/restaurant/opening-hours", 
    method: "PUT",
    body: data,
  }),
}),
    
    // Kitchen status
    isKitchenOpen: builder.query({
      query: () => "/restaurant/is-open",
    }),
    
    isKitchenOpenOnDate: builder.query({
      query: (date) => `/restaurant/is-open/${date}`,
    }),


  }),
  
  
});

// ===== ALL EXPORTS =====
export const {
  // Alert Email
  useUpdateAlertEmailMutation,
  useGetAlertEmailQuery,
  
  // Alert SMS
  useGetAlertSMSQuery,
  useUpdateAlertSMSMutation,
  
  // Checklist Due Time
  useUpdateCheckDueTimeMutation,
  useGetCheckDueTimeQuery,
  
  // Incident Due Time
  useUpdateIncidentDueTimeMutation,
  useGetIncidentDueTimeQuery,
  
  // Timezone
  useUpdateTimezoneMutation,
  useGetTimezoneQuery,
  
  // Monthly Due Time
  useGetMonthlyDueTimeQuery,
  useUpdateMonthlyDueTimeMutation,
  
  // Checklist Settings
  useFetchChecklistSettingsQuery,
  
  // Checklist Visibility
  useGetChecklistVisibilityQuery,
  useUpdateChecklistVisibilityMutation,
  useGetChecklistTypeVisibilityQuery,
  useUpdateChecklistTypeVisibilityMutation,
  useResetChecklistVisibilityMutation,
  useBulkUpdateVisibilityMutation,

  useGetHolidayStatusQuery,
  useGetOpeningHoursQuery,
  useUpdateOpeningHoursMutation,
  useIsKitchenOpenQuery,
  useIsKitchenOpenOnDateQuery,
  useEnableHolidayModeMutation,   
  useDisableHolidayModeMutation, 
} = settingApi;